<template>
  <div>
    <app-detail-header :show-toggle="true"
      :show-new="false"
      :show-print="false"
      :show-delete="entity && !entity.deleted && !entity.isNew"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <country-setting-side-menu v-if="entity"
          ref="sideMenu"
          :entity-name="entity.countryCode" />
      </div>

      <div class="column">
        <router-view v-if="entity"
          v-model="entity"
          ref="currentChild"
          :is-tiled="false"
          :key="$route.fullPath"
          :route-name="$route.name" />
        <!-- <country-setting-detail v-if="entity"
          v-model="entity"
          :is-new="isNew" /> -->
      </div>
    </div>

    <unsaved-modal :active.sync="isUnsavedModalActive"
      @close="closeModal"
      @skipSave="skipSave"
      @saveContinue="saveContinue">
      <p slot="text-title">Unsaved Changes</p>
      <p slot="text-content">There are unsaved changes. Please select action below</p>
    </unsaved-modal>
    <confirm-modal v-if="entity && entity.countryDesc"
      :active.sync="isConfirmModalActive"
      @ok="deleteEntity(true)"
      @cancel="deleteEntity(false)"
      :ok-text="'Yes'"
      :cancel-text="'No'">
      <p slot="text-title">Delete Country</p>
      <p slot="text-content">
        Country
        <span class="has-text-primary has-text-weight-bold">{{ `${entity.countryDesc}` }}</span> will be deleted. Continue?
      </p>
    </confirm-modal>
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import CountrySettingSideMenu from './CountrySettingSideMenu'
// import CountrySettingDetail from './CountrySettingDetail'
import CountrySettingService from './CountrySettingService'
import CountrySettingValidation from './CountrySettingValidation'
import StoreMixin from './storeMixin'
import { UnsavedModal } from '@/components/BulmaModal'
import routeTypes from './route-types'
import _cloneDeep from 'lodash/cloneDeep'
import _debounce from 'lodash.debounce'
// import _isEmpty from 'lodash/isEmpty'
import { AppHeaderButtonTypes, EventHubTypes } from '@/enums'
import { ConfirmModal } from '@/components/BulmaModal'

export default {
  name: 'CountrySettingView',
  components: {
    AppDetailHeader,
    [CountrySettingSideMenu.name]: CountrySettingSideMenu,
    // CountrySettingDetail,
    UnsavedModal,
    ConfirmModal
  },
  mixins: [CountrySettingValidation, StoreMixin],
  props: {
    isNew: Boolean,
    returnUrl: String
  },
  data() {
    return {
      entity: null,
      isUnsavedModalActive: false,
      isSkipSave: false,
      isSaveContinue: false,
      toRoute: null,
      isConfirmModalActive: false
    }
  },
  computed: {
    validateError() {
      return this.$v.$error || this.$v.detailGroup.$error
    }
  },
  watch: {
    entity: {
      handler: _debounce(function (newVal) {
        if (newVal) {
          this.$forceUpdate()
          this.saveSnapshot(_cloneDeep(this.entity))
        }
      }, 500),
      deep: true
    }
  },
  beforeDestroy() {
    // this.clearSessionStorage()
    // this.clearSnapshots(this.entity.countryId)
  },
  async created() {
    if (this.returnUrl) {
      this.persistQueries()
      this.replaceRoute(this.$route.params.countryId)
    }
    await this.getEntity()
  },
  methods: {
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.Print:
          break
        case AppHeaderButtonTypes.Delete:
          this.isConfirmModalActive = true
          // if (this.entity) {
          //   this.entity.deleted = true
          //   this.saveSnapshot(_cloneDeep(this.entity))
          //   this.save(true)
          // }
          break
        case AppHeaderButtonTypes.Save:
          this.save()
          break
        case AppHeaderButtonTypes.Cancel:
          this.cancel()
          break
      }
    },
    removeQueries() {
      sessionStorage.removeItem(`${this.$userInfo.sessionId}|country|returnUrl`)
      sessionStorage.removeItem(`${this.$userInfo.sessionId}|country|type`)
    },
    clearSessionStorage() {
      this.removeQueries()
    },
    async getEntity(reset = false) {
      try {
        this.$showSpinner()
        if (reset) {
          this.clearSessionStorage()
          this.clearSnapshots(this.$route.params.countryId)
        }
        if (!this.currentSnapshot) {
          await this.getStoreItem(this.$route.params.countryId)
        }
        this.entity = _cloneDeep(this.currentSnapshot)
      } catch (e) {
        this.$notification.openMessageXhrError('', e)
      }
      this.$hideSpinner()
    },
    async save(isDelete) {
      const title = 'Country Setting'

      if (this.validateError) {
        this.$notification.openNotificationWithType('danger', title, 'Validation errors. Please fix before saving')
        return false
      }
      try {
        this.$showSpinner('Saving...')
        if (this.entity.isNew) {
          await CountrySettingService.postCountrySetting(this.entity)
        } else if (this.snapshotDiff) {
          await CountrySettingService.putCountrySetting(_cloneDeep(this.entity), this.snapshotDiff)
        } else {
          this.$notification.openNotificationWithType('warning', title, 'No changes detected. Not saved')
          return false
        }

        this.$notification.success(title, isDelete ? 'Set to In-Active' : 'Save successful')
        if (!this.isSaveContinue) await this.getEntity(true)
        this.$eventHub.$emit(EventHubTypes.EntitySaved)
        return true
      } catch (e) {
        console.log(e)
        this.$notification.openMessageXhrError(title, e)
        return false
      } finally {
        this.$hideSpinner()
      }
    },
    async deleteEntity(saveEntity) {
      this.isConfirmModalActive = false
      this.entity.deleted = saveEntity
      if (saveEntity) {
        this.saveSnapshot(_cloneDeep(this.entity))
        this.save(true)
      }
    },
    cancel() {
      if (this.returnUrl) {
        if (this.snapshotDiff && !this.isSkipSave && !this.isSaveContinue) {
          this.isUnsavedModalActive = true
        } else {
          this.redirectToQueryUrl(this.returnUrl)
        }
      } else if (this.toRoute) {
        this.$router.push(this.toRoute.fullPath)
      } else {
        this.$router.push({ name: routeTypes.CountrySettingListView.name })
      }
    },
    skipSave() {
      this.isUnsavedModalActive = false
      this.isSkipSave = true
      this.cancel()
    },
    async saveContinue() {
      this.isUnsavedModalActive = false
      this.isSaveContinue = true
      const ok = await this.save()
      if (ok) this.cancel()
    },
    closeModal() {
      this.isUnsavedModalActive = false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.snapshotDiff && !this.isSkipSave && !this.isSaveContinue) {
      this.toRoute = to
      this.isUnsavedModalActive = true
      this.$router.replace(from.path)
    } else {
      this.clearSnapshots(this.entity && this.entity.countryId)
      this.clearSessionStorage()
      next()
    }
  }
}
</script>
